import { useSessionVoucherStore } from '../../stores/sessionVoucher'
import { useNotificationsStore } from '../../stores/notifications'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!import.meta.client) return

  const rawSessionVoucher = to?.query?.c?.toString()

  const sanitizeVoucherCode = (code: string | undefined) => {
    if (!code) return undefined
    return code.replace(/[^a-zA-Z0-9_-]/g, '').toUpperCase()
  }

  const sessionVoucher = sanitizeVoucherCode(rawSessionVoucher?.toString())
  const store = useSessionVoucherStore()
  const { addNotification } = useNotificationsStore()
  const { t } = useNuxtApp().$i18n

  const hasRun = useState('voucherValidated', () => false)
  if (hasRun.value) return

  const subdomain = useSubdomain()
  const partnerData = subdomain.value
    ? (await useSubdomainData()).data.value
    : undefined

  const supplierId =
    supplierGetters.getId(partnerData || undefined) || undefined

  const voucherCode = sessionVoucher || store.voucherCode
  if (!voucherCode) return

  try {
    await store.validateVoucher(voucherCode, supplierId || undefined, undefined)

    store.showVoucherNotification()

    hasRun.value = true
  } catch (e: any) {
    const message = e?.data?.message || t('cart.sessionVoucher.errorMessage')
    addNotification({ type: 'ERROR', message, showIcon: true })
  }
})
